import { CustomListFieldApi, WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class CustomListFieldService {

    public static CreateMemberUploadTemplate = async (listId: number) => {
        return new CustomListFieldApi(GetApiConfiguration()).apiCustomListFieldCreateCustomListUploadTemplateListIdPostRaw({ listId: listId });
    }

    public static GetCCustomListFields = async (listId: number) => {
        return new CustomListFieldApi(GetApiConfiguration()).apiCustomListFieldGetCustomFieldsListIdGet({ listId: listId });
    };

    public static GetCustomListFieldsUpload = async (listId: number) => {
        return new CustomListFieldApi(GetApiConfiguration()).apiCustomListFieldCreateCustomListUploadTemplateListIdPost({ listId: listId });
    };

    public static SaveCustomListFields = async (request: WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto) => {
        return new CustomListFieldApi(GetApiConfiguration()).apiCustomListFieldSaveMemberFieldsPost({
            webApiCustomListFieldsDtoSaveCustomFieldSettingsDto: request
        });
    };
}